export default __webpack_public_path__ + "static/simulating_work-3bc8c4aa493db7dba7b4b465575ebb38.png";